<template>
  <div class="form_root">
    <div class="text-left">
      <h3>
        <router-link to="/tarefas">Tarefas</router-link> » {{crud_action}}
        <button v-if="!loading" @click.prevent="save()" class="btn btn-success pull-right">Salvar</button>
        <button v-else class="btn btn-muted pull-right">Aguarde...</button>
      </h3>
      <hr>
    </div>
    <!-- Cliente --> 
    <div class="form-group col-sm-12">
      <label class="control-label">Cliente</label>
      <h3>{{cliente.razao}}</h3>
      <cite>{{cliente.endereco}}</cite>
    </div>
    <div class="row">
    <template v-for="telefone in cliente.telefone"> 
      <div class="form-group col-sm-2"><b>{{maskTelefone(telefone.numero)}}</b><br><small>{{telefone.descricao.substring(0,20) + '...'}}</small></div>
    </template>
  </div>
    <!-- Descrição -->
    <div class="form-group col-sm-2">
      <label class="control-label">Onde?</label>
      <select v-model="form.codlocal" id="" class="form-control">
        <option value="15">PsWeb » Outro</option>
        <option value="0">CTE » Autorização</option>
        <option value="1">MDFE » Autorização</option>
        <option value="2">MDFE » Digitação</option>
        <option value="3">NFCE » Autorização</option>
        <option value="4">NFE » Autorização</option>
        <option value="5">NFSE » Autorização</option>
        <option value="6">NFSE » Digitação</option>
        <option value="7">Not.Entrada » Digitação</option>
        <option value="8">Not.Entrada » Fechamento</option>
        <option value="9">Not.Entrada » XML</option>
        <option value="10">Ped.Venda » Digitação</option>
        <option value="11">Ped.Venda » Fechamento</option>
        <option value="12">Relatórios</option>
        <option value="13">Remessa</option>
        <option value="14">Impressões</option>
        <option value="16">Ps2000 » Outro</option>
        
      </select>
    </div>
    <div class="form-group col-sm-2">
      <label class="control-label">Tipo de tarefa</label>
      <select v-model="form.tipo" id="" class="form-control">
          <option value="0">Atualizar</option>
          <option value="1">Backup do cliente</option>
          <option value="2">Bug / Investigar</option>
          <option value="3">Certificado Digital</option>
          <option value="4">Configurar</option>
          <option value="5">Desenvolver</option>
          <option value="12">Duvidas e Treinamento</option>
          <option value="6">Erro NFE</option>
          <option value="7">Impressora</option>
          <option value="8">Instalar Sistema</option>
          <option value="9">Ligar</option>
          <option value="10">Mandar Boleto</option>
          <option value="11">Pacote Atualização</option>
          <option value="12">Remessa Bancária</option>
        </select>
    </div>
    <div class="form-group col-sm-2">
      <label class="control-label">Urgência</label>
      <select v-model="form.flag" id="" class="form-control">
        <option value="0">Imediato</option>
        <option value="1">Urgente</option>
        <option value="2">Moderada</option>
        <option value="3">Normal</option>
        <option value="4">Quando possível</option>
        <option value="5">Quando visitar</option>
        <option value="7">Não Pode Atualizar</option>
      </select>
    </div>
    <div class="form-group col-sm-2">
      <label class="control-label">Responsável</label>
      <select v-model="form.codresponsavel" name="" id="" class="form-control">
        <option value="1">Alguem</option>
        <option value="2">Fabio</option>
        <option value="3">Felipe</option>
        <option value="4">Jair</option>
        <option value="5">Josue</option>
        <option value="6">Lucas</option>
        <option value="7">Prado</option>
        <option value="8">Regis</option>
        <option value="9">Roberto</option>
        <option value="10">Rodrigo</option>
        <option value="11">Sanguine</option>
        <option value="12">Valni</option>
      </select>     
    </div>
    <div class="col-sm-2">
      <label for="">Data Máxima</label>
      <div class="input-group">
        <input ref="dtlimitedisplay" value="" type="text" class="form-control" disabled>
        <div class="input-group-btn">
          <button class="btn btn-primary" @click="showCalendar=true"><i class="glyphicon glyphicon-calendar"></i></button>
          <Calendario v-if="showCalendar" @pickDate="setDate" class="calendario"></Calendario>
        </div>
      </div>
    </div>
    <div class="form-group col-sm-2">
      <label class="control-label">Situação</label>
      <select v-model="form.situacao" id="" class="form-control">
        <option value="0">Aberto</option>
        <option value="1">Re-Aberto</option>
        <option value="2">Devendo retorno...</option>
        <option value="3">Aguardando análise...</option>
        <option value="4">Aguardando desenv...</option>
        <option value="5">Aguardando retorno...</option> 
        <option value="6">Resolvido</option>
        <option value="7">Não Pode Atualizar</option>
      </select>
    </div>
    <div class="form-group col-sm-12">
      <label class="control-label">Resumo da Situação</label>
      <input type="text" v-model="form.descr" class="form-control" max-length="255" placeholder="Máx 255 caracteres">
    </div>
    <div class="row">
      <div class="form-group col-sm-6">
        <label class="control-label">Situação</label>
        <wysiwyg ref="descricao"></wysiwyg>
      </div>
      <div class="form-group col-sm-6">
        <label class="control-label">Soluçao</label>
        <wysiwyg ref="solucao"></wysiwyg>
      </div>
    </div>
  </div>
</template>

<script>
import wysiwyg from './Wysiwyg'
import Calendario from './Calendar'
import swal from 'sweetalert'
import Mask from './Mask.js'
export default {
  name: '',
  components: {
    wysiwyg, Calendario
  },
  data () {
    return {
      loading: false,
      crud_action: '',
      showCalendar: false,
      form: {
        cod: 0,
        codcli: 0,
        flag: '3',
        tipo: '0',
        situacao: '0',
        dt_insert: '',
        dt_limite: null,
        dt_resolvido: null,
        codautor: '0',
        codresponsavel: '1',
        codsolucionador: '0',
        descr: '',
        descricao: '<b>teste</b>',
        solucao: '',
        codlocal: '15'
      },
      cliente: {
        razao: '',
        endereco: '',
        telefone: []
      }
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/gettarefa.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.fetchData(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    loadCliente (cod) {
      const url = './api/php/getcliente.php'
      this.$http.post(url, JSON.stringify({'cod': cod})).then(
        function (response) {
          // console.log(response.body)
          this.fetchDataCliente(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    fetchData (o) {
      this.form = o
      this.$refs.descricao.setContent(o.descricao)
      this.$refs.solucao.setContent(o.solucao)
      this.loadCliente(o.codcli)
    },
    fetchDataCliente (o) {
      console.log(o)
      this.form.codcli = o.cod
      this.cliente.cod = o.cod
      this.cliente.razao = o.razao
      this.cliente.telefone = o.telefone
      if (o.endrua === '') {
        this.cliente.endereco = o.cobrua + ', ' + o.cobnumero + ' ' + o.cobcompl + ' - ' + o.cobbairro + ', ' + o.cobcidade + ' - ' + o.cobuf
      } else {
        this.cliente.endereco = o.endrua + ', ' + o.endnumero + ' ' + o.endcompl + ' - ' + o.endbairro + ', ' + o.endcidade + ' - ' + o.enduf
      }
    },
    save () {
      if (this.form.situacao === '6') this.form.tmpcodsolucionador = this.$root.cod
      this.form.descricao = this.$refs.descricao.getContent()
      this.form.solucao = this.$refs.solucao.getContent()
      const url = './api/php/addtarefa.php'
      this.$http.post(url, JSON.stringify(this.form)).then(
        function (response) {
          console.log(response.body)
          if (this.crud === 'c') {
            swal('Tarefa salva.', 'success')
          } else {
            swal('Tarefa alterada', '', 'success')
          }
          this.closeForm()
        },
        function (error) {
          console.log(error)
        }
      )
    },
    setDate (date) {
      console.log('DtPicked: ' + date)
      this.showCalendar = false
      this.$refs.dtlimitedisplay.value = this.formatData(date)
      this.form.dt_limite = date
    },
    formatData (date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4)
      }
    },
    closeForm () {
      this.$router.go(-1)
    }
  },
  created: function () {
    const crud = this.$route.params.crud
    const cod = this.$route.params.id
    this.maskTelefone = Mask.telefone
    if (crud === 'c') {
      // Criar nova tarefa
      console.log('Criando nova tarefa')
      this.crud_action = 'Nova'
      this.form.codautor = this.$root.cod
      this.loadCliente(cod)
    } else if (crud === 'u') {
      // Altera uma tarefa
      console.log('Alterando uma tarefa')
      this.crud_action = 'Alterando (#' + cod + ')'
      this.load({'cod': cod})
    } else {
      console.log('CRUD INVÁLIDO EM FORM TAREFA')
    }
  }
}
</script>

<style scoped>
  .loading {
    background: url("../assets/loading.gif") center no-repeat;
    background-size: cover;
    display: block;
    width: 30vw;
    height: 30vh;
    margin: 25vh 35vw;
  }
  .form_root {
      text-align: left;
      margin: auto;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TarForm.vue